
import {

  get_BotList,
  insert_into_table,
} from "../../../helpers/fakebackend_helper";
import { set_open_create_new_bot } from "../../groups/reducer";
import { open_success_modal } from "../../Success_Modal/reducer";

// action
import {
  fetch_Bot_List_Failed,
  fetch_Bot_List_Successful,
  reset_bot_list_Change,
  set_insert_values,
  start_loader_bot_list
} from "./reducer";



export const bot_list = (filterData) => async (dispatch, getStates) => {
  
  try {
    let response;
         dispatch(start_loader_bot_list())      

      response = get_BotList(filterData);
      const data = await response;
          

       if(data.data.length ===0  && !getStates().Group_List.No_Group_Created ){
           dispatch(set_open_create_new_bot(true))
           dispatch(fetch_Bot_List_Successful(data));

       }else{

         dispatch(fetch_Bot_List_Successful(data));
       }

    
  } catch (error) {
    
    dispatch(fetch_Bot_List_Failed(error));
  }
};

export const reset_bot_list = () => {
  try {
    const response = reset_bot_list_Change();
    return response;
  } catch (error) {
    return error;
  }
};


export const INSERT_INTO_TABLE= (filterData) => async (dispatch, getStates) => {
  
  try {
    let response;

   

      response = insert_into_table(filterData);
      const data = await response;
      dispatch(set_insert_values(data))
      const { Inserted_Values,Insertion_Query,insert_table,searchable_column }=data
         let search_value = Inserted_Values.map((ele)=>{
        return ele[`${searchable_column}`]
    })

    search_value = [...new Set(search_value)];  
      dispatch(open_success_modal(`Table Insertion Done as ${searchable_column}  with ${search_value.join(",")} in ${insert_table}  `))

    
  } catch (error) {
    
          // dispatch(open_success_modal(`${error.message}`))
          console.log("Error generating INsert Query ....")

  }
};



